import styled from 'styled-components';

import {
  Image as SemanticImage,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Text = styled(TextLayoutComponent)`
  text-align: justify;
  word-break: break-word;
`;

export const Image = styled(SemanticImage)`
  && {
    max-width: 90px;
    max-height: 60px;
  }
`;

export const ContainerImageName = styled.div`
  display: flex;
  flex-direction: column;
`;
